export const motionFadeUp = {
    initial: { opacity: 1, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 20 },
    transition: { duration: 0.25 },
};

export const motionFadeIn = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.25 },
};

const defaultEase = [0.26, 0.02, 0.23, 0.94];
export const motionPopLayout = {
    initial: { opacity: 0, scale: 0.6 },
    animate: {
        opacity: 1,
        scale: 1,
        ease: defaultEase,
    },
    exit: {
        opacity: 0,
        scale: 0.8,
        ease: defaultEase,
    },
    transition: { duration: 0.3 },
};
